import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function everyFilterMustHaveValueValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const filterCriteria = control as FormArray;

    if (!filterCriteria || filterCriteria.length === 0) {
      return { noFilterCriteria: true };
    }

    const everyFilterHasValue = filterCriteria.controls.every((group: AbstractControl) => {
      if (group instanceof FormGroup && group.contains('values')) {
        const valuesControl = group.get('values');

        if (valuesControl instanceof FormArray) {
          return valuesControl.length > 0;
        } else if (typeof valuesControl?.value === 'string') {
          return valuesControl.value.trim() !== '';
        } else if (Array.isArray(valuesControl?.value)) {
          return valuesControl?.value.length > 0;
        } else {
          return valuesControl?.value !== null && valuesControl?.value !== undefined;
        }
      }
      return false;
    });

    return everyFilterHasValue ? null : { everyFilterMustHaveValue: true };
  };
}
